import Inspector from './inspector';
const { RichText, InnerBlocks } = wp.blockEditor;
import SvgCheckIcon from '../../images/SvgCheckIcon';

export default ({ attributes, setAttributes }) => {
  const { title, hasIcon, icon, image, variant, align, color, margin, iconPosition } =
    attributes;
  const ALLOWED_BLOCKS = ['base/heading-sumicity', 'base/paragraph-sumicity'];

  const justTitle = variant === 'just-title';
  const imageDescription = variant === 'image-description'
  const titleMargin = justTitle ? 'margin-none' : 'margin-extra-small';

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <div className={`TopicItem ${variant} ${margin}`}>
        <div
          className={`TopicItem__title ${titleMargin} ${iconPosition} ${color}`}
        >
          {hasIcon && (
            <span className={`TopicItem__title--icon`}>
              {icon.src ? (
                <img src={icon.src} alt={icon.alt} />
              ) : (
                <SvgCheckIcon />
              )}
            </span>
          )}

          {!justTitle && !imageDescription ? (
            <RichText
              tagName="h3"
              className={`Typography subtitle ${align}  margin-none`}
              value={title}
              placeholder="Texto (tag h3)"
              keepPlaceholderOnFocus
              onChange={(title) => setAttributes({ title })}
            />
          ) : !justTitle && imageDescription ? (
            <div className='topic-with-image'>
              <img src={image.src} alt={image.alt} />
              <InnerBlocks allowedBlocks={[['base/heading-sumicity']]} template={[['base/heading-sumicity']]}/>
            </div>) : (
            <InnerBlocks
              allowedBlocks={[['base/heading-sumicity']]}
              template={[['base/heading-sumicity']]}
            />
          )}
        </div>

        {!justTitle && !imageDescription && <InnerBlocks allowedBlocks={ALLOWED_BLOCKS} />}
      </div>
    </>
  );
};
